import extend from 'extend'
import uuid from 'uuid/v4'

export const defaultOperatingHours = [
    { value: [{ value: null }, { value: null }] },
    { value: [{ value: null }, { value: null }] },
    { value: [{ value: null }, { value: null }] },
    { value: [{ value: null }, { value: null }] },
    { value: [{ value: null }, { value: null }] },
    { value: [{ value: null }, { value: null }] },
    { value: [{ value: null }, { value: null }] }
]

const initiatedStatus = 1

export const defaultOffer = {
    name: { value: '' },
    status: { value: 1 },
    description: { value: '' },
    marketingCategory: { value: '' },
    expiration: { value: null },
    language: { value: '' },
    content: {
        children: {
            body: {
                value: ''
            }
        }
    }
}

export const defaultReportSettings = {
    digitals: [{
        description: {
            value: ''
        },
        url: {
            value: ''
        }
    }],
    programs: [
        {
            program: {
                value: ''
            },
            url: {
                value: ''
            }
        }
    ]
}

export const defaultBatchEditOffer = {
    marketingCategory: { value: '' },
    expiration: { value: null },
    language: { value: '' },
    title: { value: '' },
    subtitle: { value: '' },
    body: { value: '' },
    offerText: { value: '' },
    validity: { value: '' },
    termsAndConditions: { value: '' },
    days: { value: '' },
    date: { value: null },
    dateRangeStart: { value: null },
    dateRangeEnd: { value: null },
    offerURL: { value: '' }
}

export const defaultTemplate = {
    name: { value: '' },
    description: { value: '' },
    marketingCategory: { value: '' },
    channel: { value: { 1: true } },
    expiration: { value: null },
    language: { value: '' },
    jobCode: { value: '' },
    approvalRequired: {
        value: false
    },
    cost: { value: '' },
    templates: {
        value: [{
            children: {
                channel: { value: 1 },
                template: { value: 1 },
                content: {
                    children: {
                        subject: { value: '' },
                        preheader: { value: '' },
                        body: { value: '' }
                    }
                }
            }
        }]
    },
    programTypes: {
        value: [{
            value: 1
        }]
    },
    status: {
        value: 1
    }
}

export const SELECTED_SCHEDULE_DISPLAY = {
    1: 'Does not repeat',
    2: 'Recurring',
    3: 'Multiple specific dates'
}

export const IMMEDIACY_TYPE = {
    1: 'Send immediately'
}

export const defaultMessageObject = {
    defineData: {},
    browseAllAudience: false,
    currentStep: 0,
    history: {
        content: {
            history: {
                value: []
            }
        }
    },
    draftMessage: {},
    activeMessage: {},
    selectedAudienceId: [],
    selectedAudienceArray: [],
    selectedEstimatedConsumers: null,
    selectedEmail: {},
    selectedTemplate: {},
    selectedMessageId: {},
    selectedScheduleData: null,
    selectedScheduleDateList: null,
    testEmailSent: false,
    typedValues: {},
    workspaceOrn: '',
    editClicked: false,
    isActiveEditFlow: false,
    isDisabled: false,
    isViewActiveMessage: false,
    previousMessageName: null,
    isMessageChanged: false,
    isReviewPageClicked: false,
    recentTestEmails: { selectedEmails: [], updatedEmails: [] },
    message: {
        name: {},
        goal: null,
        audiences: null,
        template: null,
        channelData: null,
        schedule: null,
        status: null
    }
}

export const defaultDefineObject = {
    name: { value: '' },
    description: { value: '' },
    goal: { value: '1' },
    channel: { value: { 1: true } },
    message_expire_on: { value: '' }
}

/**
 * Read the expiration date (epoch seconds) from a message returned by the API. A wrapped { value } form and an
 * unset field both resolve to a plain number or null so the Define form and the review page can rely on it.
 * @param {Object} messageData - Message content from the API
 * @returns {number|null}
 */
export const getMessageExpireOn = (messageData) => {
    const expireOn = messageData ? messageData.message_expire_on : null

    if (expireOn && typeof expireOn === 'object') {
        return expireOn.value || null
    }

    return expireOn || null
}

export const defaultFromEmail = {
    fromEmailList: { value: '' },
    friendlyFromName: { value: '' }
}

export const getDefaultDateTimeItem = {
    date: { value: null },
    time: { value: '' }
}

export const defaultScheduleData = {
    sendDate: { value: null },
    immediacy: { value: '' },
    date: { value: null },
    time: { value: '' },
    repeat: { value: '' },
    repeatEveryCount: { value: '' },
    repeatEvery: { value: '' },
    repeatEveryMonth: { value: '' },
    endsOption: { value: 1 },
    week: { value: null },
    endDate: { value: null },
    endAfterCount: { value: '' }
}

export const customAudienceRequestObject = {
    id: { value: null },
    name: { value: 'custom-audience-request' },
    question: { value: 'Can\'t find the audience that you need?' },
    description: { value: 'Submit a request for custom audience' }
}

export const customAudienceRequestValidationObject = {
    description: { value: '' }
}

export const getDefaultSeasonalOffers = () => ({
    children: {
        id: { value: 'tmnaNationalPromotion' },
        channels: []
    }
})

export const getDefaultLocation = () => ({
    children: {
        id: { value: uuid() },
        city: { value: '' },
        contactEmail: { value: '' },
        contactName: { value: '' },
        contactPhone: { value: '' },
        contactTitle: { value: '' },
        email: { value: '' },
        latitude: { value: '' },
        longitude: { value: '' },
        name: { value: '' },
        operatingHours: {
            value: defaultOperatingHours.map((day) => {
                return extend(true, {}, day)
            })
        },
        phone: { value: '' },
        tollFreePhone: { value: '' },
        phoneContactHours: {
            value: defaultOperatingHours.map((day) => {
                return extend(true, {}, day)
            })
        },
        radius: { value: '' },
        replyToEmail: { value: '' },
        replyToPhone: { value: '' },
        seedEmail: { value: '' },
        state: { value: '' },
        addressLine1: { value: '' },
        addressLine2: { value: '' },
        marketingAutomationDefaultFromEmail: { value: '' },
        messageGalleryFromEmail: { value: '' },
        webUrl: { value: '' },
        zip: { value: '' },
        friendlyFromName: { value: '' }
    }
})

export const extractItemValue = (item, key, defaultValue = '') => {
    return item[key] && item[key].value
        ? item[key]
        : { value: defaultValue }
}

export const extractChildren = (item, key) => {
    return item[key] && item[key].children
        ? item[key]
        : { children: {} }
}

export const resolveMetadataRef = (root, obj) => {
    if (!obj) {
        return obj
    }

    if (Array.isArray(obj)) {
        return obj.map(item => resolveMetadataRef(root, item))
    }

    if (typeof obj === 'object') {
        const { ref, ...others } = obj
        let resolvedRefObj = null
        if (ref) {
            const parts = ref.split('.')

            let refObj = root
            while (parts.length > 0) {
                const part = parts.splice(0, 1)
                refObj = refObj[part]
            }

            resolvedRefObj = resolveMetadataRef(root, refObj)
        }

        const result = {}
        Object.keys(others).forEach(key => {
            result[key] = resolveMetadataRef(root, others[key])
        })

        return extend(true, {}, resolvedRefObj, result)
    }

    return obj
}

export const organizeItem = (item, type) => {
    if (!item) {
        return null
    }

    const d = new Date()
    d.setFullYear(d.getFullYear() + 3)
    const defaultAssetExpiration = d.getTime()

    const organizedItem = {
        header: {
            name: extractItemValue(item, 'name'),
            status: extractItemValue(item, 'status', initiatedStatus)
        },
        about: {
            legacyGsmId: extractItemValue(item, 'legacyGsmId'),
            gsmId: extractItemValue(item, 'gsmId'),
            industry: extractItemValue(item, 'industry'),
            name: extractItemValue(item, 'name'),
            phoneNumber: extractItemValue(item, 'phone'),
            address: extractItemValue(item, 'address'),
            city: extractItemValue(item, 'city'),
            state: extractItemValue(item, 'state'),
            zip: extractItemValue(item, 'zip'),
            latitude: extractItemValue(item, 'latitude', 0),
            longitude: extractItemValue(item, 'longitude', 0),
            timeZone: extractItemValue(item, 'timeZone', 'CT'),
            companyUrl: extractItemValue(item, 'companyUrl'),
            facebookUrl: extractItemValue(item, 'facebookUrl'),
            twitterUrl: extractItemValue(item, 'twitterUrl'),
            linkedinUrl: extractItemValue(item, 'linkedinUrl'),
            youtubeUrl: extractItemValue(item, 'youtubeUrl'),
            instagramUrl: extractItemValue(item, 'instagramUrl'),
            snapchatUrl: extractItemValue(item, 'snapchatUrl'),
            privacyPolicyURL: extractItemValue(item, 'privacyPolicyURL'),
            serviceAppointmentSchedulerUrl: extractItemValue(item, 'serviceAppointmentSchedulerUrl'),
            contactName: extractItemValue(item, 'contactName'),
            contactTitle: extractItemValue(item, 'contactTitle'),
            contactEmail: extractItemValue(item, 'contactEmail'),
            contactPhone: extractItemValue(item, 'contactPhone'),
            primaryNotificationEmail: extractItemValue(item, 'primaryNotificationEmail'),
            secondaryNotificationEmail: extractItemValue(item, 'secondaryNotificationEmail'),
            marketingRadius: extractItemValue(item, 'marketingRadius'),
            odometerMax: extractItemValue(item, 'odometerMax'),
            modelYearMin: extractItemValue(item, 'modelYearMin'),
            modelYearMax: extractItemValue(item, 'modelYearMax'),
            makesServiced: extractItemValue(item, 'makesServiced', []),
            dealerPrimaryMake: extractItemValue(item, 'dealerPrimaryMake', null),
            defaultServiceTime: extractItemValue(item, 'defaultServiceTime', null),
            defaultServiceMileage: extractItemValue(item, 'defaultServiceMileage', null)
        },
        branding: {
            logo: extractItemValue(item, 'logo'),
            currency: extractItemValue(item, 'currency'),
            language: extractItemValue(item, 'language')
        },
        billing: {
            emailUsage: extractItemValue(item, 'emailUsage', 0),
            emailSpend: extractItemValue(item, 'emailSpend', 0),
            mailUsage: extractItemValue(item, 'mailUsage', 0),
            mailSpend: extractItemValue(item, 'mailSpend', 0),
            socialUsage: extractItemValue(item, 'socialUsage', 0),
            socialSpend: extractItemValue(item, 'socialSpend', 0),
            phoneUsage: extractItemValue(item, 'phoneUsage', 0),
            phoneSpend: extractItemValue(item, 'phoneSpend', 0),
            digitalUsage: extractItemValue(item, 'digitalUsage', 0),
            digitalSpend: extractItemValue(item, 'digitalSpend', 0),
            assetExpiration: extractItemValue(item, 'assetExpiration', defaultAssetExpiration),
            dataRetentionRules: extractItemValue(item, 'dataRetentionRules', 0)
        },
        locationDetails: {
            locationDetails: {
                value: extractItemValue(item, 'locationDetails', []).value.map((location) => {
                    const loc = { children: {} }
                    const defaultLocation = getDefaultLocation()
                    Object.keys(defaultLocation.children).map((key) => {
                        loc.children[key] = location.children[key] || defaultLocation.children[key]
                    })
                    loc.children.industry = location.children.industry
                    loc.children.department = location.children.department
                    return loc
                })
            }
        },
        affiliations: {
            affiliates: extractItemValue(item, 'affiliates', [])
        },
        globalFeatures: {
            contentManagement: extractItemValue(item, 'contentManagement', false),
            dataManagement: extractItemValue(item, 'extractItemValue', false),
            programManagement: extractItemValue(item, 'extractItemValue', false),
            rollupReporting: extractItemValue(item, 'extractItemValue', false),
            rollupBilling: extractItemValue(item, 'extractItemValue', false)
        },
        proofs: {
            orn: extractItemValue(item, 'orn')
        },
        miscSettings: {
            dailyMailLimit: extractItemValue(item, 'dailyMailLimit', null),
            stateInspectionFrequency: extractItemValue(item, 'stateInspectionFrequency', null),
            stateInspectionState: extractItemValue(item, 'stateInspectionState', null),
            surveySalesWelcome: extractItemValue(item, 'surveySalesWelcome', false),
            surveyServiceThankYou: extractItemValue(item, 'surveyServiceThankYou', false),
            isTxmMember: extractItemValue(item, 'isTxmMember', false),
            hasMessageSubscription: extractItemValue(item, 'hasMessageSubscription', false),
            oemCoverageType: extractItemValue(item, 'oemCoverageType', 0),
            triggerSettings: extractChildren(item, 'triggerSettings'),
            sodAudienceSettings:extractChildren(item, 'sodAudienceSettings'),
        },
        actions: {
            siloId: extractItemValue(item, 'id')
        },
        seasonalOffers: {
            seasonalOffers: {
                value: extractItemValue(item, 'seasonalOffers', []).value.map((location) => {
                    const seasonalOffersData = { children: {} }
                    const defaultseasonalOffers = getDefaultSeasonalOffers()
                    Object.keys(defaultseasonalOffers.children).map((key) => {
                        seasonalOffersData.children[key] = location.children[key] || defaultseasonalOffers.children[key]
                    })

                    return seasonalOffersData
                })
            }
        },
        reportSettings: {
            reportSettings: extractItemValue(item, 'reportSettings', extend(true, {}, { digitals: [], programs: [] }))
        }
    }

    organizedItem.header.status.value = parseInt(organizedItem.header.status.value)

    if (type === 'account') {
        organizedItem.about.ospreyId = extractItemValue(item, 'id')
    }
    else if (type === 'silo') {
        organizedItem.about.id = extractItemValue(item, 'id')
        organizedItem.eventCalendar = {
            events: extractItemValue(item, 'eventCalendar', [])
        }
        organizedItem.dataIdentification = {
            dataIdentification: extractItemValue(item, 'dataIdentification', [])
        }
    }
    organizedItem.export = { ...organizedItem }
    return organizedItem
}

export const organizeItemMetadata = (metadata, type) => {
    if (!metadata) {
        return null
    }

    const resolvedMetadata = resolveMetadataRef(metadata, metadata)

    const organizedMetadata = {
        status: resolvedMetadata[type].status,
        about: {
            legacyGsmId: resolvedMetadata[type].legacyGsmId,
            gsmId: resolvedMetadata[type].gsmId,
            industry: resolvedMetadata[type].industry,
            name: resolvedMetadata[type].name,
            address: resolvedMetadata[type].address,
            city: resolvedMetadata[type].city,
            state: resolvedMetadata[type].state,
            zip: resolvedMetadata[type].zip,
            phoneNumber: resolvedMetadata[type].phoneNumber,
            latitude: resolvedMetadata[type].latitude,
            longitude: resolvedMetadata[type].longitude,
            timeZone: resolvedMetadata[type].timeZone,
            companyUrl: resolvedMetadata[type].companyUrl,
            facebookUrl: resolvedMetadata[type].facebookUrl,
            twitterUrl: resolvedMetadata[type].twitterUrl,
            linkedinUrl: resolvedMetadata[type].linkedinUrl,
            youtubeUrl: resolvedMetadata[type].youtubeUrl,
            instagramUrl: resolvedMetadata[type].instagramUrl,
            snapchatUrl: resolvedMetadata[type].snapchatUrl,
            privacyPolicyURL: resolvedMetadata[type].privacyPolicyURL,
            serviceAppointmentSchedulerUrl: resolvedMetadata[type].serviceAppointmentSchedulerUrl,
            contactName: resolvedMetadata[type].contactName,
            contactTitle: resolvedMetadata[type].contactTitle,
            contactEmail: resolvedMetadata[type].contactEmail,
            contactPhone: resolvedMetadata[type].contactPhone,
            primaryNotificationEmail: resolvedMetadata[type].primaryNotificationEmail,
            secondaryNotificationEmail: resolvedMetadata[type].secondaryNotificationEmail,
            marketingRadius: resolvedMetadata[type].marketingRadius,
            odometerMax: resolvedMetadata[type].odometerMax,
            modelYearMin: resolvedMetadata[type].modelYearMin,
            modelYearMax: resolvedMetadata[type].modelYearMax,
            makesServiced: resolvedMetadata[type].makesServiced,
            dealerPrimaryMake: resolvedMetadata[type].dealerPrimaryMake,
            defaultServiceTime: resolvedMetadata[type].defaultServiceTime,
            defaultServiceMileage: resolvedMetadata[type].defaultServiceMileage
        },
        branding: {
            logo: resolvedMetadata[type].logo,
            currency: resolvedMetadata[type].currency,
            language: resolvedMetadata[type].language
        },
        billing: {
            emailUsage: resolvedMetadata[type].emailUsage,
            emailSpend: resolvedMetadata[type].emailSpend,
            mailUsage: resolvedMetadata[type].mailUsage,
            mailSpend: resolvedMetadata[type].mailSpend,
            socialUsage: resolvedMetadata[type].socialUsage,
            socialSpend: resolvedMetadata[type].socialSpend,
            phoneUsage: resolvedMetadata[type].phoneUsage,
            phoneSpend: resolvedMetadata[type].phoneSpend,
            digitalUsage: resolvedMetadata[type].digitalUsage,
            digitalSpend: resolvedMetadata[type].digitalSpend,
            assetExpiration: resolvedMetadata[type].assetExpiration,
            dataRetentionRules: resolvedMetadata[type].dataRetentionRules
        },
        locationDetails: resolvedMetadata[type].locationDetails,
        affiliations: resolvedMetadata[type].affiliates,
        globalFeatures: {},
        miscSettings: {
            dailyMailLimit: resolvedMetadata[type].dailyMailLimit,
            stateInspectionFrequency: resolvedMetadata[type].stateInspectionFrequency,
            stateInspectionState: resolvedMetadata[type].stateInspectionState,
            surveySalesWelcome: resolvedMetadata[type].surveySalesWelcome,
            surveyServiceThankYou: resolvedMetadata[type].surveyServiceThankYou,
            isTxmMember: resolvedMetadata[type].isTxmMember,
            hasMessageSubscription: resolvedMetadata[type].hasMessageSubscription,
            oemCoverageType: resolvedMetadata[type].oemCoverageType,
            triggerSettings: resolvedMetadata[type].triggerSettings
        },
        actions: {},
        reportSettings: {
            reportSettings: resolvedMetadata[type].reportSettings
        }
    }

    if (type === 'account') {
        organizedMetadata.about.ospreyId = resolvedMetadata[type].ospreyId
    }
    else if (type === 'silo') {
        organizedMetadata.about.id = resolvedMetadata[type].id
        organizedMetadata.eventCalendar = resolvedMetadata[type].eventCalendar
        organizedMetadata.dataIdentification = resolvedMetadata[type].dataIdentification
        organizedMetadata.export = { ...organizedMetadata }
    }

    return organizedMetadata
}

export const organizeImageMetadata = (metadata) => {
    if (!metadata) {
        return null
    }

    const organizedMetadata = resolveMetadataRef(metadata, metadata)

    organizedMetadata.image.licensing = {
        label: 'Licensing',
        description: 'Customize the way users are allowed to access images.',
        options: [
            { key: 'copy', value: organizedMetadata.image.allowCopy.label }
        ],
        type: 'checkGroup'
    }
    delete organizedMetadata.image.allowCopy

    return organizedMetadata
}

export const organizeTemplateMetadata = (metadata) => {
    if (!metadata) {
        return null
    }

    const organizedMetadata = resolveMetadataRef(metadata, metadata)
    return organizedMetadata
}

export const defaultAccount = {
    accountName: { value: '' },
    accountPhone: { value: '' },
    accountStreet: { value: '' },
    accountCity: { value: '' },
    accountState: { value: '' },
    accountZip: { value: '' },
    accountPafId: { value: '' },
    emailFromName: { value: '' },
    gsmId: { value: '' },
    legacyId: { value: '' }
}


// WEBPACK FOOTER //
// src/services/data-organizer/index.js